<template>
  <div v-if="fieldElevationMap.status === 'Completed'">
    <v-simple-table dense class="transparent elevationTable">
      <template v-slot:default>
        <tbody>
          <tr>
            <th>{{ $tt('fieldElevation.updatedAt') }}</th>
            <td>{{ fieldElevationMap.updatedAt | aidToYearMonthDayHourMin }}</td>
          </tr>
          <tr>
            <th>{{ $tt('fieldElevation.meshSize') }}</th>
            <td>{{ fieldElevationMap.meshSize }} m</td>
          </tr>
          <tr>
            <th>{{ $tt('fieldElevation.taskFetchLimit') }}:</th>
            <td>{{ fieldElevationMap.taskFetchLimit }}</td>
          </tr>
          <tr>
            <th>{{ $tt('fieldElevation.taskDateRange') }}</th>
            <td>
              {{ fieldElevationMap.oldestTaskDate | aidToYearMonthDay }}
              -
              {{ fieldElevationMap.newestTaskDate | aidToYearMonthDay }}
            </td>
          </tr>
          <tr>
            <th>{{ $tt('fieldElevation.taskPointCount') }}</th>
            <td>
              {{ fieldElevationMap.taskPointCount }}
            </td>
          </tr>
          <tr>
            <th>{{ $tt('fieldElevation.gnssStatus') }}</th>
            <td>
              {{ getGnssStatusFilter() }}
            </td>
          </tr>
          <tr v-if="showElevationRange">
            <th>{{ $tt('fieldElevation.elevationRange') }}</th>
            <td>{{ getZRange() }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
  <div v-else></div>
</template>

<script>
import * as Constants from '@/lib/constants'

export default {
  name: 'FieldElevationSummaryComponent',
  props: {
    fieldElevationMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showElevationRange: false,
    }
  },
  methods: {
    getGnssStatusFilter() {
      const gsFilter = this.fieldElevationMap.gnssStatusFilter
      if (gsFilter) {
        const matched = Constants.FieldElevationMap.GNSS_STATUS_FILTERS.find(f => f.value === gsFilter)
        if (matched) {
          return matched.text
        }
      }
      return 'Any'
    },
    getZRange() {
      const zMin = this.fieldElevationMap.zRangeMin
      const zMax = this.fieldElevationMap.zRangeMax
      if (!zMin && !zMax) {
        return '-'
      }
      return zMin + ' m - ' + zMax + ' m'
    },
  },
}
</script>

<style scoped>
.elevationTable th {
  padding: 0;
}
.elevationTable td {
  padding: 0;
}
</style>
